export default "__VITE_PUBLIC_ASSET__912d7214__"